import React from "react";
import { FormControlLabel, Radio } from "@mui/material";

interface IFormRadioProps {
    title: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export const FormRadio = (props: IFormRadioProps) => {
    return (
        <FormControlLabel
            label={props.title}
            control={
                <Radio
                    title={props.title}
                    checked={props.checked}
                    onChange={(_e, checked: boolean) => {
                        props.onChange(checked);
                    }}
                />
            }
        />
    );
};